import React, {Component, ReactElement, ReactNode} from 'react'
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import {AdminDefaultMediumButton, AdminPrimaryButton} from '../../../../styledComponents/adminPage/Buttons'
import {
    CondominiumInfo,
    NatGetCondominiumList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult
} from '../../condominium/repository/NatGetCondominiumList'
import {
    CondominiumGroupData,
    CondominiumGroupInfo2,
    CondominiumGroupInfo3,
    NatGetCondominiumGroup
} from '../../condominiumGroup/repository/NatGetCondominiumGroup'
import {
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {BackLink} from '../../../../styledComponents/adminPage/Links'
import {Messages} from '../../../../Messages'
import {SortOrder} from '../../../../components/shared/SortOrder'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    DISASTER_MODE,
    DO_OR_NOT,
    PREFECTURES_MASTER,
    SELECT_CONDOMINIUM_TYPE,
    USE_FUNCTION_ID
} from '../../../../CodeMaster'
import NatCondominiumRepo from '../../condominium/repository/NatCondominiumRepo'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import PPCheckboxGroup from '../../../../components/shared/forms/PPCheckboxGroup'
import styled from 'styled-components'
import {AdminPageHeadingArea} from '../../../../components/shared/pageBaseComponents/AdminPageHeadingArea'
import {AsyncCommunicationProps} from '../../../../components/shared/hoc/withAsyncCommunication'
import NatCondominiumGroupRepo from '../../condominiumGroup/repository/NatCondominiumGroupRepo'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import NatCondominiumGroupSelectComponent from '../NatCondominiumGroupSelectComponent'
import ListSearchFormArea from '../../../../styledComponents/adminPage/ListSearchFormArea'
import equal from 'fast-deep-equal'
import {ScheduleNotDeliveryCondominiumList as DeliveryCondominiumList} from '../../schedule/repository/NatGetSchedule'
import NatCondominiumSelectionComponentSp from './NatCondominiumSelectionComponentSp'
import {AppAdminContext} from '../../../../app/AppAdminContext'
import {FlexGrowContent, RightRowFlexContainer, RowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {Location, NavigateFunction} from 'react-router-dom'
import PPMultiSelect from '../../../../components/shared/forms/PPMultiSelect'
import NatAdminCondominiumSelectionRecode from './NatAdminCondominiumSelectionRecode'

const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'

/**
 * @param selectCondominiumType               物件選択の種別（'0'：単数選択 '1'：複数選択）
 * @param condominiumRepo                     repository
 * @param condominiumGroupRepo                repository
 * @param closeSelectCondominiumDiaLog        ダイアログ閉じるイベント
 * @param setSelectedCondominiumInfo          物件選択イベント（単数選択時のみ）
 * @param setSelectedExclusionCondominiumInfo 物件確定イベント（複数選択時のみ）
 * @param selectedCondominiumGroupId          デフォルトの物件グループID
 * @param eventEmitter                        eventEmitter
 * @param history                             history
 * @param location                            location
 * @param excludeCondominium                  選択中の物件
 * @param hiddenCancelButton                  キャンセルボタンの表示可否（true：非表示 false：表示）
 * @param unreleaseCondominiumExclusionFlg    非公開物件の表示可否（true：非表示 false：表示）
 * @param useFunctionId                       物件利用機能ID（指定した物件利用機能IDのみ取得対象とする）
 * @param title                               物件選択ダイアログのタイトル（未指定の場合は'物件選択'）
 * @param showCloseButton                     閉じるボタンの表示可否（true：表示 false：非表示）
 * @param rootCondominiumGroupId              参照対象となるトップドメインの物件グループID
 * @param disasterModeStatus                  災害時モード（指定した災害時モードのみ取得対象とする）
 */
interface Props {
    selectCondominiumType: string
    condominiumRepo: NatCondominiumRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    closeSelectCondominiumDiaLog: () => void
    setSelectedCondominiumInfo?: (selectedCondominiumInfo: CondominiumInfo) => void
    setSelectedExclusionCondominiumInfo?: (selectedExclusionCondominiumInfo: CondominiumInfo[]) => void
    selectedCondominiumGroupId?: number | null
    eventEmitter: EventEmitterExAdmin
    navigate: NavigateFunction
    location: Location
    excludeCondominium?: CondominiumInfo[] | DeliveryCondominiumList[]
    hiddenCancelButton?: boolean
    unreleaseCondominiumExclusionFlg?: boolean
    useFunctionId?: USE_FUNCTION_ID
    title?: string
    showCloseButton?: boolean
    rootCondominiumGroupId?: number
    disasterModeStatus?: DISASTER_MODE
}

interface States {
    isLoadCompleted: boolean
    searchCondition: SearchCondition
    condominiums: CondominiumInfo[]
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    searchResult: SearchResult
    clickSearchButton: boolean
    excludeCondominium: CondominiumInfo[]
    condominiumGroup: CondominiumGroupData
    loginUserCondominiumGroupId: number | null
    onlyShowExcludeCondominiums: boolean
}

export default class NatCondominiumSelectionComponent extends Component<Props & AsyncCommunicationProps, States> {
    declare context: React.ContextType<typeof AppAdminContext>

    constructor(props: Props & AsyncCommunicationProps) {
        super(props)

        const loginUserCondominiumGroupId: Nullable<number> =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)

        this.state = {
            isLoadCompleted: false,
            condominiums: [],
            searchCondition: {
                ['condominiumGroupId']: this.props.selectedCondominiumGroupId ?
                    this.props.selectedCondominiumGroupId : loginUserCondominiumGroupId ?
                        loginUserCondominiumGroupId : null,
                ['condominiumCd']: '',
                ['condominiumName']: '',
                ['prefectureCd']: null,
                ['address2']: null,
                ['detailSearchCondition']: null,
                ['billingStatus']: {
                    billingDeadline: null,
                    confirmStatus: null,
                    targetYearMonth: null,
                    electedTargetYearMonth: null,
                },
                ['unreleaseCondominiumExclusionFlg']: (this.props.selectCondominiumType ===
                    SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value ||
                    this.props.unreleaseCondominiumExclusionFlg)
                    ? DO_OR_NOT.DO.value : DO_OR_NOT.NOT.value,
                ['useFunctionId']: this.props.useFunctionId ?
                    Number(this.props.useFunctionId.value) : undefined,
                ['disasterModeStatus']: this.props.disasterModeStatus ?
                    this.props.disasterModeStatus.value : undefined,
            },
            searchConditionPageInfo: {
                ['pageNum']: 0,
                ['page']: 0,
            },
            searchConditionSortInfo: [
                new SortOrder('condominiumCd', 'asc'),
            ],
            searchResult: {
                ['total']: 0,
                ['totalPage']: 0,
                ['start']: 0,
                ['end']: 0,
            },
            clickSearchButton: false,
            excludeCondominium: (props.excludeCondominium) ? JSON.parse(JSON.stringify(props.excludeCondominium)) : [],
            condominiumGroup: {
                ['level1CondominiumGroupId']: '',
                ['level1CondominiumGroupName']: '',
                ['level1CondominiumGroupVersion']: 0,
                ['level2CondominiumGroupInfo']: [],
            },
            loginUserCondominiumGroupId: loginUserCondominiumGroupId,
            onlyShowExcludeCondominiums: false,
        }

        this.onChangeCondominiumCd = this.onChangeCondominiumCd.bind(this)
        this.onChangeCondominiumName = this.onChangeCondominiumName.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.updateSelectedCondominiumInfo = this.updateSelectedCondominiumInfo.bind(this)
        this.updateSelectedExclusionCondominiumInfo = this.updateSelectedExclusionCondominiumInfo.bind(this)
        this.onChangeSelectedCondominiumGroupId = this.onChangeSelectedCondominiumGroupId.bind(this)
        this.onChangeCondominiumMessageFlag = this.onChangeCondominiumMessageFlag.bind(this)
        this.onClickOperationButton = this.onClickOperationButton.bind(this)
        this.onClickDeselectAllExcludeCondominiumsButton = this.onClickDeselectAllExcludeCondominiumsButton.bind(this)
        this.onClickSelectAllCondominiumsButton = this.onClickSelectAllCondominiumsButton.bind(this)
        this.onChangeOnlyShowExcludeCondominiumsSwitch = this.onChangeOnlyShowExcludeCondominiumsSwitch.bind(this)
        this.onChangePrefecture = this.onChangePrefecture.bind(this)
        this.onChangeAddress2 = this.onChangeAddress2.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.setCondominiumDate()
    }

    async componentDidUpdate(prevProps: Props, prevState: States): Promise<void> {
        if (!equal(prevProps.selectedCondominiumGroupId, this.props.selectedCondominiumGroupId)) {
            await this.setCondominiumDate()
        }
    }

    async setCondominiumDate(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 物件グループマスタ取得
            const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                this.props.condominiumGroupRepo.getCondominiumGroup.bind(
                    this.props.condominiumGroupRepo,
                    this.props.rootCondominiumGroupId ? [this.props.rootCondominiumGroupId] : undefined
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (condominiumGroupResponse && condominiumGroupResponse.details) {
                if (this.props.selectCondominiumType ===
                    SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value && this.props.selectedCondominiumGroupId) {
                    if (this.props.rootCondominiumGroupId) {
                        this.setState({
                            condominiumGroup: condominiumGroupResponse.details,
                            searchCondition: {
                                ...this.state.searchCondition,
                                condominiumGroupId: this.props.rootCondominiumGroupId
                            }
                        })
                    } else {
                        this.setState({
                            condominiumGroup: this.getSelectedCondominiumGroupScope(condominiumGroupResponse.details),
                        })
                    }
                } else {
                    this.setState({
                        condominiumGroup: condominiumGroupResponse.details,
                    })
                }
            }

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    onChangeCondominiumCd(event: React.ChangeEvent<HTMLInputElement>): void {
        const seachConditions = this.state.searchCondition
        seachConditions.condominiumCd = event.target.value
        this.setState({searchCondition: seachConditions})
    }

    onChangeCondominiumName(event: React.ChangeEvent<HTMLInputElement>): void {
        const seachConditions = this.state.searchCondition
        seachConditions.condominiumName = event.target.value
        this.setState({searchCondition: seachConditions})
    }

    onChangeSelectedCondominiumGroupId(condomoniumGroupId: number): void {
        const seachConditions = this.state.searchCondition
        seachConditions.condominiumGroupId = condomoniumGroupId
        this.setState({searchCondition: seachConditions})
    }

    onChangeCondominiumMessageFlag(): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (this.state.searchCondition.unreleaseCondominiumExclusionFlg ===
            SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value) {
            searchCondition.unreleaseCondominiumExclusionFlg = SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value
        } else {
            searchCondition.unreleaseCondominiumExclusionFlg = SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value
        }
        this.setState({searchCondition: searchCondition})
    }

    onChangePrefecture(values: string[]): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.prefectureCd = values.join(',')
        this.setState({searchCondition: searchCondition})
    }

    onChangeAddress2(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition = this.state.searchCondition
        searchCondition.address2 = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    renderCondominiumTable(condominiums: CondominiumInfo[]): ReactElement {
        if (condominiums.length === 0) {
            return <Box height={'8px'}/>
        }
        const TableHeaderStyle = {
            backgroundColor: '#fafafa'
        }
        return <>
            <Box height={'16px'}/>
            <PageMainArea>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell style={TableHeaderStyle}
                                       key={'condominiumCd'} align={'left'} width={'96px'}>物件コード</TableCell>
                            <TableCell style={TableHeaderStyle} key={'condominiumName'}
                                       align={'left'}>物件名</TableCell>
                            <TableCell style={TableHeaderStyle}
                                       key={'condominiumGroupName'} align={'left'}>物件グループ</TableCell>
                            {this.props.selectCondominiumType === SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value &&
                                <TableCell style={TableHeaderStyle}
                                           key={'prefecture'} align={'left'} width={'160px'}>都道府県</TableCell>
                            }
                            {this.props.selectCondominiumType === SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value &&
                                <TableCell style={TableHeaderStyle}
                                           key={'address2'} align={'left'} width={'220px'}>市区町村</TableCell>
                            }
                            <TableCell style={TableHeaderStyle}
                                       key={'updateDatetime'} align={'left'} width={'160px'}>更新日時</TableCell>
                            {!this.props.unreleaseCondominiumExclusionFlg &&
                                <TableCell style={TableHeaderStyle}
                                           key={'status'} align={'center'} width={'80px'}>非公開</TableCell>
                            }
                            <TableCell style={TableHeaderStyle}
                                       key={'operation'} align={'center'} width={'112px'}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.condominiums.map(
                            condominium => this.renderCondominiumRecord(condominium),
                        )}
                    </TableBody>
                </Table>
            </PageMainArea>
        </>
    }


    updateSelectedCondominiumInfo(selectedCondominiumInfo: CondominiumInfo): void {
        if (this.props.setSelectedCondominiumInfo) {
            this.props.setSelectedCondominiumInfo(selectedCondominiumInfo)
        }

    }

    updateSelectedExclusionCondominiumInfo(): void {
        if (this.props.setSelectedExclusionCondominiumInfo) {
            this.props.setSelectedExclusionCondominiumInfo(this.state.excludeCondominium)
        }
    }

    onClickOperationButton(selectedCondominiumInfo: CondominiumInfo): void {

        if (this.judgSelectedExcludeCondominium(selectedCondominiumInfo.condominiumCd)) {
            // 既に選択済みの場合
            const excludeCondominium: CondominiumInfo[] = []
            this.state.excludeCondominium.map((condominiumInfo) => {
                if (condominiumInfo.condominiumCd !== selectedCondominiumInfo.condominiumCd) {
                    excludeCondominium.push(condominiumInfo)
                }
            })
            this.setState({excludeCondominium: excludeCondominium})
        } else {
            // 未選択の場合
            const excludeCondominium: CondominiumInfo[] = this.state.excludeCondominium
            excludeCondominium.push(selectedCondominiumInfo)
            this.setState({excludeCondominium: excludeCondominium})
        }
    }

    judgSelectedExcludeCondominium(condominiumCd: string): boolean {

        const selectedCondominium: CondominiumInfo | undefined =
            this.state.excludeCondominium.find(condominiumInfo => condominiumInfo.condominiumCd === condominiumCd)
        return selectedCondominium !== undefined
    }

    renderCondominiumRecord(condominium: CondominiumInfo): ReactNode {
        const isExcludeCondominium = this.judgSelectedExcludeCondominium(condominium.condominiumCd)
        if (!isExcludeCondominium && this.state.onlyShowExcludeCondominiums) {
            return
        }
        return (
            <NatAdminCondominiumSelectionRecode
                key={condominium.condominiumCd}
                selectCondominiumType={this.props.selectCondominiumType}
                unreleaseCondominiumExclusionFlg={this.props.unreleaseCondominiumExclusionFlg}
                condominium={condominium}
                isExcludeCondominium={isExcludeCondominium}
                updateSelectedCondominiumInfo={this.updateSelectedCondominiumInfo}
                onClickOperationButton={this.onClickOperationButton}
            />
        )
    }

    async onClickSearchButton(): Promise<void> {
        await this.searchCondominiums(
            this.state.searchCondition,
            this.state.searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
    }

    // 物件検索
    async searchCondominiums(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfo: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const searchParams: string[] = []
            if (searchConditionSortInfo) {

                searchConditionSortInfo.forEach((sortInfo) => {
                    searchParams.push(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
                })
            }

            // 物件一覧取得
            const getCondominiumResponse: Nullable<NatGetCondominiumList> =
                await this.props.asyncCallFunction(
                    this.props.condominiumRepo.getCondominiumList.bind(
                        this.props.condominiumRepo,
                        {...searchCondition, ...searchConditionPageInfo, sortInfo: searchParams},
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            if (getCondominiumResponse) {
                if (getCondominiumResponse.details) {
                    this.setState({
                        condominiums: getCondominiumResponse.details.condominiumInfo,
                        searchResult: getCondominiumResponse.details.searchResult,
                        clickSearchButton: true,
                    })
                }

            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onClickDeselectAllExcludeCondominiumsButton(): void {
        this.setState({
            excludeCondominium: [],
            onlyShowExcludeCondominiums: false,
        })
    }

    onClickSelectAllCondominiumsButton(): void {
        const {condominiums, excludeCondominium} = this.state
        const searchCondominiumCdMap = new Map(condominiums.map(condominium =>
            [condominium.condominiumCd, condominium]))
        const selectedCondominiumCdMap = new Map(excludeCondominium.map(condominium =>
            [condominium.condominiumCd, condominium]))

        const mergeCondominiumMap = new Map([...searchCondominiumCdMap, ...selectedCondominiumCdMap])
        this.setState({excludeCondominium: Array.from(mergeCondominiumMap.values())})
    }

    onChangeOnlyShowExcludeCondominiumsSwitch(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({onlyShowExcludeCondominiums: event.target.checked})
    }

    renderDialog(): ReactNode {
        const title = this.props.title ? this.props.title : '物件選択'
        const prefectures = PREFECTURES_MASTER.values().map(prefecture => {
            return {value: prefecture.value, label: prefecture.label}
        })
        let defaultCondominiumGroupID
        if (this.props.rootCondominiumGroupId) {
            defaultCondominiumGroupID = this.props.rootCondominiumGroupId
        } else {
            defaultCondominiumGroupID = this.props.selectedCondominiumGroupId ?
                this.props.selectedCondominiumGroupId : this.state.loginUserCondominiumGroupId
        }

        return <>
            <StyledDialog
                scroll={'paper'}
                id={'pp-dialog'}
                open={true}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                maxWidth={'xl'}
            >
                <StyledDialogFixed>
                    <AdminPageHeadingArea
                        title={title}
                        onClose={this.props.showCloseButton ? this.props.closeSelectCondominiumDiaLog : undefined}
                    />
                </StyledDialogFixed>
                <StyledDialogContent>
                    <ListSearchFormArea
                        onEnterKey={this.onClickSearchButton}
                    >
                        <Box height={'2px'}/>
                        <SearchForm>
                            <RowFlexContainer>
                                <SearchRowContainer flex={1}>
                                    <SearchLabel width={'102px'}>物件コード</SearchLabel>
                                    <SearchInputContainer>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 6,
                                                },
                                            }}
                                            placeholder={'物件コードで検索できます'}
                                            fullWidth
                                            onChange={this.onChangeCondominiumCd}
                                            defaultValue={this.state.searchCondition.condominiumCd}
                                            autoFocus
                                        />
                                    </SearchInputContainer>
                                </SearchRowContainer>
                                <Box width={'20px'}/>
                                <SearchRowContainer>
                                    <SearchLabel width={'70px'}>物件名</SearchLabel>
                                    <SearchInputContainer>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 50,
                                                },
                                            }}
                                            placeholder={'物件名で検索できます'}
                                            fullWidth
                                            onChange={this.onChangeCondominiumName}
                                            defaultValue={this.state.searchCondition.condominiumName}
                                        />
                                    </SearchInputContainer>
                                </SearchRowContainer>
                            </RowFlexContainer>
                            <RowFlexContainer>
                                <SearchRowContainer flex={1}>
                                    <SearchLabel width={'102px'}>物件グループ</SearchLabel>
                                    {this.state.condominiumGroup && <>
                                        <Box width={'600px'}>
                                            <NatCondominiumGroupSelectComponent
                                                condominiumGroup={this.state.condominiumGroup}
                                                defaultValue={defaultCondominiumGroupID}
                                                onChangeSelectedCondominiumGroupId=
                                                    {this.onChangeSelectedCondominiumGroupId}
                                                requiredFlag={true}
                                            />
                                        </Box>
                                    </>}
                                </SearchRowContainer>
                                {this.props.selectCondominiumType ===
                                    SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value &&
                                    <RightRowFlexContainer style={{padding:'8px 19px'}}>
                                        <AdminDefaultMediumButton
                                            onClick={this.onClickSearchButton}>
                                            物件を検索する
                                        </AdminDefaultMediumButton>
                                    </RightRowFlexContainer>
                                }
                            </RowFlexContainer>
                            {this.props.selectCondominiumType ===
                                SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value &&
                                <>
                                    <RowFlexContainer>
                                        <SearchRowContainer flex={1}>
                                            <SearchLabel width={'102px'}>都道府県</SearchLabel>
                                            <SearchInputContainer>
                                                <PPMultiSelect
                                                    options={prefectures}
                                                    placeholder={'都道府県を選択してください（複数可）'}
                                                    onChange={this.onChangePrefecture}
                                                    defaultValue={this.state.searchCondition.prefectureCd?.split(',')}
                                                />
                                            </SearchInputContainer>
                                        </SearchRowContainer>
                                        <Box width={'40px'}/>
                                        <SearchRowContainer>
                                            <SearchLabel width={'82px'}>市区町村</SearchLabel>
                                            <SearchInputContainer>
                                                <PPTextField
                                                    InputProps={{
                                                        inputProps: {
                                                            maxLength: 50,
                                                        },
                                                    }}
                                                    fullWidth
                                                    onChange={this.onChangeAddress2}
                                                    defaultValue={this.state.searchCondition.address2}
                                                />
                                            </SearchInputContainer>
                                        </SearchRowContainer>
                                    </RowFlexContainer>
                                    <RowFlexContainer>
                                        <SearchRowContainer flex={1}>
                                            <SearchLabel width={'102px'}>公開設定</SearchLabel>
                                            <SearchInputContainer>
                                                <PPCheckboxGroup
                                                    style={{fontSize: '0.875rem'}}
                                                    data={[{
                                                        label: '公開中の物件のみを抽出する',
                                                        checked: this.state.searchCondition
                                                                .unreleaseCondominiumExclusionFlg
                                                            === DO_OR_NOT.DO.value,
                                                    }]}
                                                    onChange={this.onChangeCondominiumMessageFlag}
                                                />
                                            </SearchInputContainer>
                                        </SearchRowContainer>
                                        <RightRowFlexContainer>
                                            <AdminDefaultMediumButton
                                                onClick={this.onClickSearchButton}>
                                                物件を検索する
                                            </AdminDefaultMediumButton>
                                        </RightRowFlexContainer>
                                    </RowFlexContainer>
                                </>
                            }
                        </SearchForm>
                    </ListSearchFormArea>
                    {(this.state.clickSearchButton || this.props.selectCondominiumType ===
                        SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value) && <>
                        <Box height={'16px'}/>
                        <RowFlexContainer>
                            {this.state.clickSearchButton && <>
                                <div style={{fontSize: '0.875rem'}}>
                                    {`検索結果：${this.state.searchResult.total}件`}
                                </div>
                                {this.state.searchResult.total === 0 && <>
                                    <Box width={'16px'}/>
                                    {Messages.IOPCC0014.toString()}
                                </>}
                            </>}
                            <FlexGrowContent/>
                            {this.props.selectCondominiumType ===
                            SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value && <>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            color={'primary'}
                                            checked={this.state.onlyShowExcludeCondominiums}
                                            onChange={this.onChangeOnlyShowExcludeCondominiumsSwitch}
                                        />
                                    }
                                    label={'選択中の物件のみを表示'}
                                    style={{fontSize: '0.875rem'}}
                                    labelPlacement={'start'}
                                />
                                <Box width={'16px'}/>
                                <div style = {{fontSize:'0.875rem'}}>
                                    {`選択中：${this.state.excludeCondominium.length}件`}
                                </div>
                                <Box width={'16px'}/>
                                <AdminDefaultMediumButton
                                    onClick={this.onClickDeselectAllExcludeCondominiumsButton}>
                                    選択中の物件を全て解除
                                </AdminDefaultMediumButton>
                                <Box width={'16px'}/>
                                <AdminDefaultMediumButton
                                    onClick={this.onClickSelectAllCondominiumsButton}>
                                    表示中の物件を全て選択
                                </AdminDefaultMediumButton>
                            </>}
                        </RowFlexContainer>
                    </>}
                    {this.renderCondominiumTable(this.state.condominiums)}
                </StyledDialogContent>
                <StyledDialogActions>
                    {this.props.selectCondominiumType === SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value &&
                    <PageFotterAreaRight>
                        <AdminPrimaryButton
                            onClick={this.updateSelectedExclusionCondominiumInfo}
                        >
                            確定する
                        </AdminPrimaryButton>
                    </PageFotterAreaRight>
                    }
                    <PageFotterAreaLeft>
                        {!this.props.hiddenCancelButton &&
                        <BackLink onClick={this.props.closeSelectCondominiumDiaLog}>
                            キャンセル
                        </BackLink>
                        }
                    </PageFotterAreaLeft>
                </StyledDialogActions>
            </StyledDialog>
        </>
    }

    render(): ReactNode {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }

        if (this.context.showSpModePage) {
            return <NatCondominiumSelectionComponentSp
                selectCondominiumType={this.props.selectCondominiumType}
                condominiumGroup={this.state.condominiumGroup}
                closeSelectCondominiumDiaLog={this.props.closeSelectCondominiumDiaLog}
                selectedCondominiumGroupId={this.props.selectedCondominiumGroupId}
                loginUserCondominiumGroupId={this.state.loginUserCondominiumGroupId}
                excludeCondominium={this.state.excludeCondominium}
                hiddenCancelButton={this.props.hiddenCancelButton}
                searchCondition={this.state.searchCondition}
                onlyShowExcludeCondominiums={this.state.onlyShowExcludeCondominiums}
                condominiums={this.state.condominiums}
                onChangeCondominiumCd={this.onChangeCondominiumCd}
                onChangeCondominiumName={this.onChangeCondominiumName}
                onChangeSelectedCondominiumGroupId={this.onChangeSelectedCondominiumGroupId}
                onChangeCondominiumMessageFlag={this.onChangeCondominiumMessageFlag}
                onClickSearchButton={this.onClickSearchButton}
                updateSelectedCondominiumInfo={this.updateSelectedCondominiumInfo}
                updateSelectedExclusionCondominiumInfo={this.updateSelectedExclusionCondominiumInfo}
                onClickOperationButton={this.onClickOperationButton}
                onClickDeselectAllExcludeCondominiumsButton={this.onClickDeselectAllExcludeCondominiumsButton}
                onChangeOnlyShowExcludeCondominiumsSwitch={this.onChangeOnlyShowExcludeCondominiumsSwitch}
            />
        } else {
            return this.renderDialog()
        }
    }

    // tslint:disable-next-line:max-line-length
    getSelectedCondominiumGroupScope(
        condominiumGroupData: CondominiumGroupData): CondominiumGroupData {
        const tagetdCondominiumCd = this.props.selectedCondominiumGroupId
        const condominiumGroupInfo: CondominiumGroupData = condominiumGroupData
        let level1: Nullable<CondominiumGroupData> = null
        const level2: CondominiumGroupInfo2[] = []
        const level3: CondominiumGroupInfo3[] = []

        if (condominiumGroupData.level1CondominiumGroupId !== tagetdCondominiumCd) {
            if (condominiumGroupData.level2CondominiumGroupInfo) {
                condominiumGroupData.level2CondominiumGroupInfo.map(
                    (level2CondominiumGroup) => {
                        if (level2CondominiumGroup.level2CondominiumGroupId === tagetdCondominiumCd) {
                            const tmpCondominiumGroupData1: CondominiumGroupData = {
                                level1CondominiumGroupId:
                                level2CondominiumGroup.level2CondominiumGroupId,
                                level1CondominiumGroupName:
                                level2CondominiumGroup.level2CondominiumGroupName,
                                level1CondominiumGroupVersion:
                                level2CondominiumGroup.level2CondominiumGroupVersion,
                            }

                            if (level2CondominiumGroup.level3CondominiumGroupInfo) {
                                level2CondominiumGroup.level3CondominiumGroupInfo.map(
                                    (level3CondominiumGroup) => {
                                        const tmpCondominiumGroupData2: CondominiumGroupInfo2 = {
                                            level2CondominiumGroupId:
                                            level3CondominiumGroup.level3CondominiumGroupId,
                                            level2CondominiumGroupName:
                                            level3CondominiumGroup.level3CondominiumGroupName,
                                            level2CondominiumGroupVersion:
                                            level3CondominiumGroup.level3CondominiumGroupVersion,
                                        }
                                        if (level3CondominiumGroup.level4CondominiumGroupInfo) {
                                            level3CondominiumGroup.level4CondominiumGroupInfo.map(
                                                (level4CondominiumGroup) => {
                                                    const tmpCondominiumGroupData3:
                                                        CondominiumGroupInfo3 = {
                                                        level3CondominiumGroupId:
                                                        level4CondominiumGroup.level4CondominiumGroupId,
                                                        level3CondominiumGroupName:
                                                        level4CondominiumGroup.level4CondominiumGroupName,
                                                        level3CondominiumGroupVersion:
                                                        level4CondominiumGroup.level4CondominiumGroupVersion,
                                                    }
                                                    level3.push(tmpCondominiumGroupData3)
                                                })
                                            tmpCondominiumGroupData2.level3CondominiumGroupInfo = level3
                                        }
                                        level2.push(tmpCondominiumGroupData2)
                                    })
                                tmpCondominiumGroupData1.level2CondominiumGroupInfo = level2
                            }
                            level1 = tmpCondominiumGroupData1
                        } else {
                            if (level2CondominiumGroup.level3CondominiumGroupInfo) {
                                level2CondominiumGroup.level3CondominiumGroupInfo.map(
                                    (level3CondominiumGroup) => {
                                        if (level3CondominiumGroup.level3CondominiumGroupId ===
                                            tagetdCondominiumCd) {
                                            const tmpCondominiumGroupData1: CondominiumGroupData = {
                                                level1CondominiumGroupId:
                                                level3CondominiumGroup.level3CondominiumGroupId,
                                                level1CondominiumGroupName:
                                                level3CondominiumGroup.level3CondominiumGroupName,
                                                level1CondominiumGroupVersion:
                                                level3CondominiumGroup.level3CondominiumGroupVersion,
                                            }
                                            if (level3CondominiumGroup.level4CondominiumGroupInfo) {

                                                level3CondominiumGroup.level4CondominiumGroupInfo.map(
                                                    (level4CondominiumGroup) => {
                                                        const tmpCondominiumGroupData2: CondominiumGroupInfo2 = {
                                                            level2CondominiumGroupId:
                                                            level4CondominiumGroup.level4CondominiumGroupId,
                                                            level2CondominiumGroupName:
                                                            level4CondominiumGroup.level4CondominiumGroupName,
                                                            level2CondominiumGroupVersion:
                                                            level4CondominiumGroup.level4CondominiumGroupVersion,
                                                        }
                                                        level2.push(tmpCondominiumGroupData2)
                                                    })
                                                tmpCondominiumGroupData1.level2CondominiumGroupInfo = level2
                                            }
                                            level1 = tmpCondominiumGroupData1
                                        } else {
                                            if (level3CondominiumGroup.level4CondominiumGroupInfo) {
                                                level3CondominiumGroup.level4CondominiumGroupInfo.map(
                                                    (level4CondominiumGroup) => {
                                                        if (level4CondominiumGroup.level4CondominiumGroupId ===
                                                            tagetdCondominiumCd) {
                                                            const tmpCondominiumGroupData1: CondominiumGroupData = {
                                                                level1CondominiumGroupId:
                                                                level4CondominiumGroup.level4CondominiumGroupId,
                                                                level1CondominiumGroupName:
                                                                level4CondominiumGroup.level4CondominiumGroupName,
                                                                level1CondominiumGroupVersion:
                                                                level4CondominiumGroup.level4CondominiumGroupVersion,
                                                            }
                                                            level1 = tmpCondominiumGroupData1
                                                        }
                                                    })
                                            }
                                        }
                                    })
                            }
                        }
                    })
            }
        }
        if (level1) {
            return level1
        } else {
            return condominiumGroupInfo
        }
    }
}

NatCondominiumSelectionComponent.contextType = AppAdminContext

const StyledDialogFixed = styled.div`
  padding: 24px 24px 0;
  min-width: 960px;
`

const StyledDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root {
    padding: 0 24px 8px;
    min-width: 960px;
    font-size: 0.875rem;
  }
`

const StyledDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    padding: 8px 24px 24px;
  }
`

const StyledDialog = styled(Dialog)`
  .MuiTypography-body1 { //MUIの入力コンポーネントの文字が大きくなるのを防ぐ
    color: unset;
    font-size: unset;
    line-height: unset;
  }
  .MuiDialog-paper {
    width: 100%;
  }
`

const SearchForm = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 6px;
`

const SearchLabel = styled(Box)`
    padding-left: 12px;
    font-size: 0.875rem;
`

const SearchRowContainer = styled(Box)`
    display: flex;
    gap: 22px;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    box-sizing: border-box;
    width: 100%;
`

const SearchInputContainer = styled.div`
    width: 312px;
`
